import React, { useState, useEffect } from 'react'
import { Modal, DatePicker } from 'antd'
import { isMonthSelectable } from '../../pages/invoices/invoiceReview'
import { dsButtonPrimary, dsButtonSecondary, dsButtonSpinnerInline, joinButtonClasses } from '../../utils/buttonStyles'

// Lets HR ask for the invoice to carry a different month; `range` is {min, max} as 'YYYY-MM'.
const RequestInvoiceDateModal = ({ visible = false, invoiceNo = '', range = {}, submitting = false, serverError = '', close = () => {}, submitHandler = () => {} }) => {
  const [month, setMonth] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!visible) return
    setMonth(null)
    setError('')
  }, [visible])

  const handler = () => {
    if (!month) setError('Please choose a month')
    else submitHandler(month.format('YYYY-MM'))
  }

  return (
    <Modal visible={visible} centered width='520px' footer={null} onCancel={close} maskClosable={!submitting}>
      <h1 className='text-xl mb-1 font-extrabold text-gray-700'>Request a different date for {invoiceNo}</h1>
      <p className='mb-5 text-gray-500'>The invoice will be dated the last day of that month (today for the current month), if ekincare finance agrees.</p>

      <label className='block mb-1 font-semibold text-gray-700'>Month</label>
      <DatePicker.MonthPicker
        value={month}
        format='MMM YYYY'
        placeholder='Choose a month'
        className='w-full'
        disabledDate={(current) => !current || !isMonthSelectable(current.format('YYYY-MM'), range)}
        onChange={(value) => { setMonth(value); setError('') }}
      />

      {(error || serverError) && <p className='mb-0 mt-3 text-red-600'>{error || serverError}</p>}

      <div className='mt-6 flex justify-end gap-3'>
        <button onClick={close} disabled={submitting} className={joinButtonClasses(dsButtonSecondary, 'h-11 px-5')}>Cancel</button>
        <button onClick={handler} disabled={submitting} className={joinButtonClasses(dsButtonPrimary, 'h-11 px-5', submitting && dsButtonSpinnerInline)}>
          {submitting ? 'Sending…' : 'Send request'}
        </button>
      </div>
    </Modal>
  )
}

export default RequestInvoiceDateModal
